import { bool } from "prop-types";
import { observer } from "mobx-react";
import { useInView } from "react-intersection-observer";
import { useStores } from "@hooks";
import { useEstimateStructure, useEstimateEditorSettings, BottomBar } from "@tools";
import { SortableListV2 } from "@components";
import { Grid } from "@material-ui/core";
import { TotalsFactory } from "./components";
import {
  TotalCompanyCost,
  TotalCost,
  TotalProfit,
  TotalProfitability
} from "./totalsTypes";

export const Totals = observer(({
  useBottomBar,
}) => {
  const { stateStore } = useStores();
  const { settings }  = useEstimateStructure();
  
  const {
    allowEdition,
    isSellerOrClient,
    useProfitability,
  } = useEstimateEditorSettings();

  const [ inViewRef, summaryVisible ] = useInView({
    root: stateStore.scrollRef,
    initialInView: true,
    threshold: 0.7,
  });
  
  const { visibleTotals } = settings;
  
  const totals = visibleTotals.filter(({noDev}) => !noDev || isSellerOrClient);
  
  const handleTotalsReorder = (list) => {
    settings.reorderTotals(list);
  };
  
  if(useProfitability)
    return (
      <Grid
        container
        ref={inViewRef}
        className="w-max mt-4"
        justifyContent="flex-end"
        spacing={5}
      >
        <TotalCompanyCost />
        <TotalCost isRevenue />
        <TotalProfit />
        <TotalProfitability />
        {
          useBottomBar &&
          <BottomBar summaryHidden={!summaryVisible} />
        }
      </Grid>
    )
  
  if(!totals.length)
    return <></>;
  
  return (
    <SortableListV2
      list={totals}
      group="totals"
      onListReorder={handleTotalsReorder}
      itemIdKey="name"
      className="w-max mt-4"
      disabled={!allowEdition}
      horizontal lockAxis
    >
      {
        totals.map(({ name }) => (
          <TotalsFactory
            key={name}
            name={name}

          />
        ))
      }
    </SortableListV2>
  );
});

Totals.propTypes = {
  useBottomBar: bool,
}